import { Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { ActivatedRoute, Data, RouterModule } from '@angular/router';
import { LeafletGroupComponent } from '@components/leaflet/group/group.component';
import { environment } from '@environment';
import { PlanktonOccurrence, createPointGeometry } from '@models';
import { PlanktonEventTitlePipe, WoRMSURLPipe } from '@pipes';
import { AuthService, TitleService } from '@services';
import { PlanktonPropertyListComponent } from '../../propertylist/propertylist.component';
import geojson from 'geojson';

@Component({
  selector: 'app-plankton-occurrence-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  imports: [
    CommonModule,
    LeafletGroupComponent,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatMenuModule,
    PlanktonEventTitlePipe,
    PlanktonPropertyListComponent,
    RouterModule,
    WoRMSURLPipe,
  ],
})
export class PlanktonOccurrenceItemComponent {
  authService = inject(AuthService);
  titleService = inject(TitleService);

  kinkoHost = environment.kinkoHost;

  route = inject(ActivatedRoute);

  occurrence = signal<PlanktonOccurrence>(
    this.route.snapshot.data['occurrence'],
  );
  title = computed(() => {
    const content = this.occurrence().content;
    let title = content.scientificName;
    if (content.lifeStage) {
      title += ' / ' + content.lifeStage;
    }
    return title;
  });

  constructor() {
    this.route.data.subscribe((data: Data) => {
      this.occurrence.set(data['occurrence']);
      this.titleService.setTitle(this.title());
    });
  }

  geometry(): geojson.FeatureCollection {
    return createPointGeometry(this.occurrence().event!);
  }
}
